import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MatButton, MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CuentasBancariasService } from 'src/app/services/cuentasBancarias/cuentasBancarias.service';
import { Dialogs } from 'src/app/ui/dialogs/dialogs';
import { Wait } from 'src/app/ui/wait/Wait';

@Component({
  selector: 'comp-cuentas-bancarias-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.css']
})
export class CuentasBancariasCreateComponent implements OnInit, AfterViewInit {

  @ViewChild('mainContainer', {static:false}) mainContainer : ElementRef;
  @ViewChild('btnGuardar', {static:false})    btnGuardar    : MatButton;
  @ViewChild('btnCerrar', {static:false})     btnCerrar     : MatButton;
  @ViewChild('ngFormGroup', {static:false})   ngFormGroup   : FormGroupDirective;

  @Output('onChange') onChange : EventEmitter<any> = new EventEmitter<any>();
  
  private boolGuardar : boolean = false;
  private objDialogs  : Dialogs = new Dialogs();
  private formGroup   : FormGroup;

  private lstEmpresas : Array<any> = [];
  private lstBancos   : Array<any> = [];

  public objData  : any = null;
  public isEdit   : boolean = false;

  constructor(private objDialogRef : MatDialogRef<CuentasBancariasCreateComponent>, 
              private objCuentasBancariasService : CuentasBancariasService,
              private toastr: ToastrService) { }

  ngOnInit() {
    
    this.formGroup = new FormGroup({
      'empresa' : new FormControl(null, [Validators.required]),
      'titular' : new FormControl(null, [Validators.required]),
      'banco'   : new FormControl(null, [Validators.required]),
      'cuenta'  : new FormControl(""),
      'clabe'   : new FormControl(null, [Validators.required])
    });

    if(this.isEdit) {
      this.formGroup.controls["titular"].setValue(this.objData.titular);
      this.formGroup.controls["cuenta"].setValue(this.objData.cuenta);
      this.formGroup.controls["clabe"].setValue(this.objData.clabe);
    }

  }

  ngAfterViewInit() {
    this.create();
  }

  // EVENTOS
  close()
  {
    if(!this.boolGuardar)
    {
      this.objDialogRef.close();
    }
  }

  btnGuardar_clickEvent()
  {
    if(this.formGroup.invalid) {
      this.toastr.warning('Datos incompletos en el formulario', 'Formulario', { timeOut: 2000 });
      this.ngFormGroup.onSubmit(undefined);
      return;
    }
    
    if(this.isEdit)
    {
      this.update();
    } else {
      this.store();
    }
  }

  // METODOS
  private loading(value : boolean) {
    if(value) {

      Wait.show(this.mainContainer, "Guardando...");
      this.btnGuardar.disabled        = true;
      this.btnCerrar.disabled         = true;
      this.boolGuardar                = true;
      this.objDialogRef.disableClose  = true;

    } else{

      Wait.hide(this.mainContainer);
      this.btnGuardar.disabled        = false;
      this.btnCerrar.disabled         = false;
      this.boolGuardar                = false;
      this.objDialogRef.disableClose  = false;

    }
  }

  private create() : void {

    this.objCuentasBancariasService.create()
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {
          
          this.lstEmpresas  = objResponse.result.empresas;
          this.lstBancos    = objResponse.result.bancos;

          if(this.isEdit) {
            var hasEmpresa = this.lstEmpresas.some(x => x.idEmpresa == this.objData.idEmpresa);

            if(hasEmpresa) {
              this.formGroup.controls["empresa"].setValue(this.objData.idEmpresa);
            }

            var hasBanco = this.lstBancos.some(x => x.idBanco == this.objData.idBanco);

            if(hasBanco) {
              this.formGroup.controls["banco"].setValue(this.objData.idBanco);
            }
          }
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.loading(false);

    }, error => {

      this.loading(false);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

  private store() : void {

    this.loading(true);

    let objCuentaBancariaStore : any =
    {
      idEmpresa : this.formGroup.controls["empresa"].value,
      titular   : this.formGroup.controls["titular"].value,
      idBanco   : this.formGroup.controls["banco"].value,
      cuenta    : this.formGroup.controls["cuenta"].value,
      clabe     : this.formGroup.controls["clabe"].value
    };

    this.objCuentasBancariasService.store(objCuentaBancariaStore)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {
          
          this.ngFormGroup.resetForm();
          this.onChange.emit(objResponse.result);
          this.objDialogs.Success(objResponse.title, objResponse.message);
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.loading(false);

    }, error => {

      this.loading(false);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

  private update() : void {

    this.loading(true);

    let objCuentaBancariaUpdate : any =
    {
      idCuentaBancaria  : this.objData.idCuentaBancaria,
      idEmpresa         : this.formGroup.controls["empresa"].value,
      titular           : this.formGroup.controls["titular"].value,
      idBanco           : this.formGroup.controls["banco"].value,
      cuenta            : this.formGroup.controls["cuenta"].value,
      clabe             : this.formGroup.controls["clabe"].value
    };

    this.objCuentasBancariasService.update(objCuentaBancariaUpdate)
    .subscribe( objResponse => {
      
      if(objResponse.session) {

        if(objResponse.action) {

          this.onChange.emit(this);
          this.objDialogs.Success(objResponse.title, objResponse.message);
          
        } else {
          this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
        }
      } else {
        this.toastr.error(objResponse.message, objResponse.title, { timeOut: 2000 });
      }

      this.loading(false);

    }, error => {

      this.loading(false);

      if( error.status == 401) {
        this.toastr.error("La sesión ha finalizado.", "Error de sesión", { timeOut: 2000 });
      } else {
        this.toastr.error("Póngase en contacto con el administrador.", "Error de conexión al servidor");
      }

    });

  }

}
